<template>
    <div style=" height: 100%;">
        <div id="tzgg-body" ref="tzggElement">
        <CCBlockFrame :header="header">
            <ul v-if="allDataList.length > 0" id="item-body" class="autoStyle">
                <template class="link-message">
                    <li v-for="(item, index) in allDataList" :key="index" class="link-message" @click="onCellLink(item, index)">
                        <div class="item">
                            <!-- <div v-if="item.readed=='0'" class="title" style="font-weight:700;"><span style="display:flex;"><span style="display: block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.flSubject }}</span> <span style="line-height: 30px;"><svg-icon style="color: #9B9B9B;font-size: 20px;" class-name="newT" icon-class="newT" /></span></span></div> -->
                            <div class="title" style="color: #333333">
                                <span class="msg">{{ item.name||item.certName }}</span>

                            </div>
                            <div class="bottom">
                                <!-- <span style="text-align:left" class="name">{{ item.wfNodeNames }}</span> -->
                                <span style="text-align: right" class="name">{{ item.certNo }}</span>
                                <span class="time">有效期:{{ item.expiredDate| dateTrans }}</span>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <div v-else>
                <div slot="empty" style="text-align: center; margin-top: 30px">
                    <img src="images/w-imgs/nomessage.png" style="max-width: 180px" />
                    <br />
                    <span v-text-lbl="'common.noData'" style="font-size: 15px; color: #dbdbdb">暂无数据</span>
                </div>
            </div>

        </CCBlockFrame>

    </div>
        <Basicform
         v-if="showdia"
        :append-to-body="true"
      :title="formTitle"
      :win-width="moduleInfo2.winWidth"
      :win-height="moduleInfo2.winHeight"
      :toolbar-btns="busiformBtns"
      :on-basic-form-before-open="onBasicFormBeforeOpen"
      :on-basic-form-opened="onBasicFormOpened"
      :on-basic-form-before-submit="onBasicFormBeforeSubmit"
      :on-basic-form-submited="onBasicFormSubmited"
    >
      <template #default="slotProps">
        <busi-form ref="formItem" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo2" />
      </template>
    </Basicform>
</div>

</template>

<script>
const moment = require('moment')
const nowTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
import { mapGetters } from 'vuex'
export default {
    name: 'PatyBuildingActivities',
    components: {},
    filters: {
        dateTrans(date) {
            if (!date) return ''
            return window.moment(date).format('YYYY年MM月DD日')
        }
    },
    props: {
        title: { type: String, default: '公告' },
        appletData: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            // 全部数据列表
            allDataList: [],
            // 数据列表
            dataList: [],
            showdia: false,
            header: {
                title: [
                    {
                        name: '企业证照',
                        code: 'zzgl',
                        click: this.tabClick
                    },
                    {
                        name: '人员资质',
                        code: 'rsgl_index_pc.svg',
                        click: this.tabClick
                    }
                ],
                more: true,
                icon: this.appletData.icon,
                code: 'zzgl'
            },
            listdataConfig: {
                // orderBy: 'pushTime desc',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc'
                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            },
            tabName: '企业证照',
            moduleInfo1: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/zzgl/certInfo/form_newLook.html',
                'winWidth': 1000,
                'delUrl': 'zzgl/certInfo/delete',
                'addNewUrl': 'zzgl/certInfo/addNew',
                'insertUrl': 'zzgl/certInfo/insert',
                'moduleCode': 'certInfo',
                'listAdvSearchExpandPanel': 0,
                'winHeight': 600,
                'updateUrl': 'zzgl/certInfo/update',
                'listDataUrl': 'zzgl/certInfo/listdata',
                'getByIdUrl': 'zzgl/certInfo/getById',
                'listAdvSearchAllFields': 0
            },
            moduleInfo2: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/zzgl/personalCertInfo/form.html',
                'winWidth': 1000,
                'delUrl': 'zzgl/personalCertInfo/delete',
                'addNewUrl': 'zzgl/personalCertInfo/addNew',
                'insertUrl': 'zzgl/personalCertInfo/insert',
                'moduleCode': 'personalCertInfo',
                'listAdvSearchExpandPanel': 0,
                'winHeight': 600,
                'updateUrl': 'zzgl/personalCertInfo/update',
                'listDataUrl': 'zzgl/personalCertInfo/listdata',
                'getByIdUrl': 'zzgl/personalCertInfo/getById',
                'listAdvSearchAllFields': 0
            }
        }
    },
    computed: {
        ...mapGetters(['loginUser', 'routes'])
    },
    watch: {},
    created() {
        this.getAllData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        tabClick(data) {
            this.tabName = data.name
            this.getTz(data.name)
        },
        async getTz(type) {
            console.log(type, 123)

            this.listdataConfig = {
                // orderBy: 'pushTime desc',
                pageNum: 1,
                pageSize: 10000,
                order: 'asc'
                // listpageViewUrl: 'djgl.inforContent.list_yfb.vue',
                // urlsearch: 'flFormName!:通知公告'
            }
            if (type === '企业证照') {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhTzggData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }

                this.$app.listdata('zzgl/certInfo/listdata', this.listdataConfig).then((res) => {
                    console.log(res)
                    this.allDataList = res.body.pageInfo.list
                })
            } else if (type === '人员资质') {
                // 是否开启伪数据
                if (this.appletData.interfaceStatus === 0 || window.openInterface) {
                    const defaultData = await this.$getDefaultData(this, this.appletData.id)
                    const list = defaultData.grmhTzData
                    this.dataList = list.splice(0, 5)
                    // this.nullProcessing('value', this.appletData.icon, this.position)
                    return
                }
                this.$app.listdata('zzgl/personalCertInfo/listdata', this.listdataConfig).then((res) => {
                    this.allDataList = res.body.pageInfo.list
                })
            }
        },
        getAllData() {
            this.$app
                .listdata('zzgl/certInfo/listdata', this.listdataConfig)
                .then((res) => {
                    this.allDataList = res.body.pageInfo.list
                })
                .finally(() => {
                    this.loading = false
                })
        },
        onCellLink(row) {
            // if (this.appletData.interfaceStatus === 0 || window.openInterface) {
            //     this.$bus.emit('openDefaultDialog', this.appletData.name)
            //     return
            // }
            console.log(row, 1)
            if (this.tabName === '企业证照') {
                window.open('#/newBusiForm?voId=' + row.id + '&moduleInfo=' + encodeURIComponent(JSON.stringify(this.moduleInfo1)) + '&title=' + encodeURIComponent('证照管理') + '&busiInfo=' + encodeURIComponent('证照信息') + '&formUrl=zzgl.certInfo.form_newLook&innerUrl=zzgl.certInfo.form_newInnerLook&noEdit=true')
            } else {
                this.showdia = false
                var _this = this
                _this.formTitle = '人员资质'
                _this.busiformBtns = [
		  {
                        id: 'btn_close',
                        btnName: '关 闭',
                        btnIcon: 'close',
                        btnClick: 'closeDialog',
                        btnPermission: '',
                        btnType: ''
		  }
                ]
                this.showdia = true
                _this.moduleInfo2.formTemplate = '#/dcontent/vuebusiform/W/zzgl.personalCertInfo.form.vue?sysCode='
                _this.$options.components['BusiForm'] = _this.$loadComponent(_this.moduleInfo2.formTemplate)
                _this.$nextTick(() => {
		  _this.$bus.emit('openBusiform', _this.moduleInfo2, row, 0, (res) => {
                        this.showdia = false
		  })
                })
            }
        }
    }
}
</script>

  <style scoped lang="scss">
#tzgg-body {
    height: 100%;
    // @import url(); 引入公共css类
    #item-body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        .link-message + .link-message {
            border-top: 1px dashed #ebeef5;
            // border-top:none !important;
        }
        .link-message {
            width: 100%;
            height: 71px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            list-style: none;
            padding: 10px 20px;
            .item {
                // padding: 10px 0;
                width: 100%;
                height: 100%;
            }

            cursor: pointer;
            &:hover {
                // background-color: #F5F7FA;
            }
            &:last-child {
                border-bottom: none;
            }
            .title {
                font-size: 14px;
                color: #333333;
                height: 25px;
                line-height: 25px;
                width: 100%;
                position: relative;
                padding-right: 10px;
                display: inline-block;
                display: flex;
                .msg {
                    display: block;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    width: 100%;
                }
                .no-read {
                    display: block;
                    width: 6px;
                    height: 6px;
                    border-radius: 6px;
                    background: red;
                    position: absolute;
                    left: -10px;
                    top: 12px;
                    z-index: 100;
                }
            }
            .bottom {
                font-size: 13px;
                color: #9b9b9b;
                height: 25px;
                line-height: 25px;
                font-family: MicrosoftYaHei;
                .name {
                    display: inline-block;
                    width: 60%;
                    text-align: left !important;
                    font-size: 13px;
                }
                .time {
            display: block;
            display: inline-block;
            font-size: 13px;
            font-family: MicrosoftYaHei;
            color: #ec8423;
            text-align: right;
            width: 40%;
        }
                .sender {
                    font-size: 12px;
                }
            }
        }
    }

    // .autoStyle{
    //     height: 100px !important;
    //     overflow-y: auto;
    // }
    // .autoStyle::-webkit-scrollbar{
    //     display: none;
    // }
}
</style>
